import { AdminAppState, PlaceEntry, PosterImageType } from '../../state';
import { getPlacePosterImages } from './get-place-poster-images';

export const getPlacePosterImage = (
  placeKey: string,
  type: PosterImageType = PosterImageType.Generic,
) => (state: AdminAppState): PlaceEntry['place']['posterImages'][0] | null => {
  const posterImages = getPlacePosterImages(placeKey)(state);
  return posterImages.find(image => image.type === type) || null;
};
